import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import {formatDate} from '@angular/common';

export interface Term {
  id: number;
  title: string;
  startDate: Date;
  startDateUTC: Date;
  endDate: Date;
  endDateUTC: Date;
  period: number;
  metrics: number[];
}
export interface Metric {
  id: number;
  override: boolean;
  title: string;
  type: number;
  decimalDigits: number;
  options: string;
  hasGoal: boolean;
  goalAlert: boolean;
  hasCustomGoal: boolean;
  goalTitle: boolean;
  goalType: boolean;
  goalDescription: boolean;
  editable: boolean;
  description: string;
}
export interface MetricValue{
  [key: string]: number;
}
export interface Period {
  label: string;
  date: Date;
  dateEnd: Date;
  dateString: string;
}
export interface MetricType{
  name: string;
  symbol: string;
}
export interface Usermeta{
  id: number;
  title: string;
  type: number;
  defaultValue: string;
  options: string[];
  viewOnly: boolean;
  linkedField: string;
  value: string;
}
@Injectable({
  providedIn: 'root'
})
export class AppService {
  public monthNames = [ 'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December' ];
  // url: 'https://ontraninja.com/'
  public config = {
    url: 'http://localhost:4200/wp/',
    ssoUrl: 'https://my.vitalstats.live/users/sso_auth'
  };
  constructor(private http: HttpClient) { }
  setApiUrl(url): void{
    this.config.url = url;
  }
  convertUTCDateToLocalDate(date: Date): Date{
    const newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

    //var offset = date.getTimezoneOffset() / 60;
    //var hours = date.getHours();

    //newDate.setHours(hours - offset);

    return newDate;
  }
  getPeriods(term: Term): Period[]{
    term.startDate = this.convertUTCDateToLocalDate(term.startDateUTC);
    term.endDate = this.convertUTCDateToLocalDate(term.endDateUTC);
    //console.log(term.startDate);
    //console.log(term.endDate);
    const d = new Date(term.startDate.getTime());
    switch (term.period){
      case 0:
        const result: Period[] = [];
        if (term.startDate < term.endDate) {
          let month = term.startDate.getMonth();
          for (; month < term.endDate.getMonth() +
                 1 + ((term.endDate.getFullYear() -
            term.startDate.getFullYear()) * 12); month++) {
            result.push({
              label: this.monthNames[month % 12].substring(0, 3),
              date: new Date(d.getTime()),
              dateEnd: new Date(d.getTime()),
              dateString: formatDate(new Date(d.getTime()), 'yMMdd', 'en-US')
            });
            d.setMonth(d.getMonth() + 1);
          }
        }
        //console.log(result);
        return result;
        break;
      case 1:
        let diff = (term.endDate.getTime() - term.startDate.getTime()) / 1000;
        diff /= (60 * 60 * 24 * 7);
        return [...Array(Math.abs(Math.round(diff))).keys()].map(i => {
          if ( i > 0){
            d.setDate(d.getDate() + 7);
          }
          const dEnd = new Date(d.getTime());
          dEnd.setDate(dEnd.getDate() + 6);
          return {
            label: 'Week ' + (i + 1),
            date: new Date(d.getTime()),
            dateEnd: new Date(dEnd.getTime()),
            dateString: formatDate(new Date(d.getTime()), 'yMMdd', 'en-US')
          };
        });
        break;
    }
  }
  getDefaultTerm(): Term {
    let today: Date;
    today = new Date();
    let startMonth;
    let endMonth;
    switch (today.getMonth()){
      case 0: case 1: case 2:
        startMonth = 0;
        endMonth = 2;
        break;
      case 3: case 4: case 5:
        startMonth = 3;
        endMonth = 5;
        break;
      case 6: case 7: case 8:
        startMonth = 6;
        endMonth = 8;
        break;
      default:
        startMonth = 9;
        endMonth = 11;
        break;
    }
    return {
      id: Math.floor(Math.random() * 100000),
      title: 'Reporting Period',
      startDate: new Date(today.getFullYear(), startMonth, 1, 0, 0, 0),
      startDateUTC: new Date(Date.UTC(today.getFullYear(), startMonth, 1, 0, 0, 0)),
      endDate: new Date(today.getFullYear(), endMonth + 1, 0, 0, 0, 0),
      endDateUTC: new Date(Date.UTC(today.getFullYear(), endMonth + 1, 0, 0, 0, 0)),
      period: 0,
      metrics: []
    };
  }
  checkLogin(): Observable<any>{
    return this.http.post(this.config.url + '?wpmm_ajax=1&action=checkLogin', {});
  }
  addBusiness(): Observable<any>{
    return this.http.post(this.config.url + '?wpmm_ajax=1&action=addBusiness', {});
  }
  deleteBusiness(id: any): Observable<any>{
    return this.http.post(this.config.url + '?wpmm_ajax=1&action=deleteBusiness', {
      id
    });
  }
  getSettings(post: number, userId: number): Observable<any>{
    return this.http.post(this.config.url + '?wpmm_ajax=1&action=getSettings', {
      post,
      userId
    });
  }
  getMetrics(post: number): Observable<any>{
    return this.http.post(this.config.url + '?wpmm_ajax=1&action=getMetrics', {
      post
    });
  }
  newMetric(): Observable<any>{
    return this.http.post(this.config.url + '?wpmm_ajax=1&action=newMetric', {});
  }
  saveSettings(post: number, terms: Term[], metrics: Metric[]): Observable<any>{
    return this.http.post(this.config.url + '?wpmm_ajax=1&action=saveSettings', {
      post,
      terms,
      metrics
    });
  }
  getValues(post: number, userId: number): Observable<any>{
    return this.http.post(this.config.url + '?wpmm_ajax=1&action=getValues', {
      post,
      userId
    });
  }
  saveValues(post: number, userId: number, metricValues: MetricValue, businesses: any, goalScreenActive: any): Observable<any>{
    return this.http.post(this.config.url + '?wpmm_ajax=1&action=saveValues', {
      post,
      userId,
      metricValues,
      businesses: JSON.stringify(businesses),
      goalScreenActive: goalScreenActive ? 1:0
    });
  }
  saveUserSettings(usermeta: Usermeta[], userId: number): Observable<any>{
    return this.http.post(this.config.url + '?wpmm_ajax=1&action=saveUserSettings', {
      usermeta,
      userId
    });
  }
  ssoLogin(kfSso: string, kfCompany: string): Observable<any>{
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'KF-SSO': kfSso,
      'KF-Company': kfCompany,
    });
    const options = { headers, withCredentials: true, dataType: 'json' };
    return this.http.post(this.config.ssoUrl, null, options);
  }
}
